import type { GlucoseStandardDeviationInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCalculationsContext } from "../CalculationsContext"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileUnit } from "./TileUnit"
import { TileValue } from "./TileValue"
import {
  useReadableGlucoseUnit,
  useDisplayGlucoseValue,
} from "src/hooks"

export function GlucoseStandardDeviation(props: TileProps<GlucoseStandardDeviationInsight>) {
  const {
    insightKey,
    range,
  } = props

  const glucoseUnit = useReadableGlucoseUnit()
  const displayGlucoseValue = useDisplayGlucoseValue()
  const { glucoseCalculations } = useCalculationsContext()
  const { standardDeviation } = glucoseCalculations[range] || {}

  const value = isNaN(standardDeviation) || standardDeviation === undefined
    ? "--"
    : displayGlucoseValue(standardDeviation)

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TileValue
        id={`${insightKey}-value`}
      >
        {`±${value}`}
      </TileValue>
      <TileUnit id={`${insightKey}-unit`}>
        {glucoseUnit}
      </TileUnit>
    </>
  )
}
